// EPC page component
export function EPCPage() {
  return `
<div class="hero">
  <div class="hero-content">
    <h1 class="hero-title">About Energy Certificates</h1>
    <p class="hero-subtitle">The energy certificate required by law</p>
  </div>
</div>

<section class="section bg-gray-50">
  <div class="container">
    <div class="max-w-6xl mx-auto prose prose-lg">

      <div class="flex flex-col md:flex-row md:items-start md:space-x-8">

        <div class="bg-white p-8 rounded-lg shadow-sm md:w-2/3">

          <h2 class="text-2xl text-blue-900 mb-4">Request your energy certificate quickly and easily through EPCspainhomes.com</h2>

          <p>The energy certificate (Energy Efficiency Certificate) indicates how energy efficient your home or commercial property is in Spain. Valuable information! But why is this certificate mandatory? And what is it for?</p>

          <h3 class="text-xl text-blue-900 mt-4 mb-2">Why an energy certificate in Spain?</h3>
          <p>The planet is warming, and in Spain, regulations are also becoming increasingly strict to reduce energy consumption and CO₂ emissions. A large part of these emissions comes from buildings: heating, cooling, and lighting consume a lot of energy. To make this visible, the Spanish government (according to Royal Decree 390/2021) has made the energy certificate mandatory. This way, everyone can see how efficient a building is and energy savings are encouraged.</p>

          <p>The energy certificate is mandatory in Spain when you want to:</p>
          <ul>
            <li>sell a home or premises,</li>
            <li>rent it out, or</li>
            <li>build a new one.</li>
          </ul>

          <p>Without a valid certificate (Energy Efficiency Certificate), the property cannot be officially advertised, and you may receive a fine between €300 and €6,000, depending on the severity of the infraction.</p>

          <p class="mt-4 mb-2"><a href="/epc/info/#why-energy-label" data-route="/epc/info/#why-energy-label" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Read more about why an energy certificate is important →</a></p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">What is an energy certificate?</h3>
          <p>The Spanish energy certificate compares the energy performance of buildings. The certificate shows a rating from A to G:</p>
          <ul>
            <li>A means very energy efficient</li>
            <li>G means the building consumes a lot of energy</li>
          </ul>

          <p>The score is based on factors such as:</p>
          <ul>
            <li>insulation of walls, windows, and roofs,</li>
            <li>the type of heating and cooling system,</li>
            <li>ventilation, and</li>
            <li>renewable energies such as solar panels or heat pumps.</li>
          </ul>

          <p>The certificate is prepared by an authorized certifying technician who inspects the property according to the official methodology.</p>

          <p>Not sure if your home already has a valid certificate? You can check it in the Regional Register of Energy Efficiency Certificates of your community (for example: Andalusia, Valencia, Madrid, etc.).</p>

          <p>An energy certificate in Spain is valid for ten years.</p>

          <p class="mt-4 mb-2"><a href="/epc/info/#what-is-energy-label" data-route="/epc/info/#what-is-energy-label" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Read more about what exactly an energy certificate includes →</a></p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">What is the purpose of an energy certificate?</h3>
          <p>In addition to being mandatory for sale, rental, or new construction, the certificate offers practical advantages:</p>
          <ul>
            <li>You immediately see how efficient your home is.</li>
            <li>You know where you can improve to save energy (and money).</li>
            <li>A better certificate usually increases the value and rental potential of your home.</li>
          </ul>

          <p class="mt-4 mb-2"><a href="/epc/info/#what-is-the-benefit-of-an-energy-label" data-route="/epc/info/#what-is-the-benefit-of-an-energy-label" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Read more about the benefits of an energy certificate →</a></p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">Frequently asked questions about energy certificates in Spain</h3>
          <p>Do you have questions about requesting or renewing an energy certificate? We have created a handy summary with frequently asked questions.</p>

          <p class="mt-4 mb-2"><a href="/faq-customer/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Go to all frequently asked questions →</a></p>

        </div>

        <div class="p-8 rounded-lg shadow-sm md:w-1/3" style="background: linear-gradient(335deg, rgba(63, 137, 233, 0.85), rgba(121, 211, 238, 0.75));">
          <img src="/images/team/compare.webp" alt="Compare energy certificate advisors" class="mb-4 w-full h-auto rounded-md object-cover" />

          <p class="mb-4">Compare energy certificate advisors.  
          Compare prices, quality, and speed based on your data.</p>

          <p><a href="/cadastro/" data-route="/cadastro/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Compare now -></a></p>
        </div>

      </div>

    </div>
  </div>
</section>

  `;
}
